import { WantedBooking } from '../features/bookings/bookingsSlice';
import { pineAppleDay, pineAppleTime } from './utils';

export interface BookingWindow {
  day: string;
  from: string;
  to: string;
}

/**
 * The installer slot a DGtek sign up booked, as words.
 *
 * Answers null when there is no slot to show, which is the normal case on
 * Community Fibre: they connect the service themselves, so nothing is booked.
 * Reading the slot regardless is what printed "undefined NaN undefined between
 * 12:NaN am and 12:NaN am" on the confirmation page.
 */
export const bookingWindow = (
  booking: WantedBooking | undefined,
  state?: string,
): BookingWindow | null => {
  const start = Number(booking?.start);
  const end = Number(booking?.end);
  if (!Number.isFinite(start) || !Number.isFinite(end) || start <= 0 || end <= 0) {
    return null;
  }
  return {
    day: pineAppleDay(new Date(start)),
    from: pineAppleTime(new Date(start), state),
    to: pineAppleTime(new Date(end), state),
  };
};
